'use strict';

var CogMenuDirective = function CogMenuDirective() {
  return {
    restrict: 'E',
    template: require('../templates/cog-menu.html'),
    controller: 'CogMenuController',
    scope: {
      optionSet: '=',
      cogId: '@'
    }
  };
};
CogMenuDirective.$inject = [];
module.exports = CogMenuDirective;